import { render, staticRenderFns } from "./Pen.vue?vue&type=template&id=0206cf34"
import script from "./Pen.vue?vue&type=script&lang=js"
export * from "./Pen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports